import Alpine from "alpinejs";

Alpine.store('basket', {
    basketProducts: [],
    basketNotification: false,

    init() {
        function loadBasketProducts() {
            console.log('Load basket');
            let storedProducts = window.localStorage.getItem('_basket');
            console.log('storedProducts: ', storedProducts);
            if (storedProducts) this.basketProducts = JSON.parse(storedProducts) || [];
        }

        window.addEventListener('window-reload', () => {
            console.log('Load basket event');
            loadBasketProducts();
        })
        loadBasketProducts.call(this);
    },

    isBasketEmpty() {
        return !!this.basketProducts.length;
    },

    getTotalBasketPrice() {
        let sum = 0;
        this.basketProducts.map(item => {
            sum += Alpine.store('products').getProductById(item.id)?.price * item.count;
        })
        return sum;
    },

    getTotalBasketWeight() {
        let sum = 0;
        this.basketProducts.map(item => {
            sum += Alpine.store('products').getProductById(item.id)?.weight * item.count;
        })
        return sum;
    },

    add(productId, count) {
        let product = this.basketProducts.find(p => p.id === productId);
        if (product) {
            product.count += count;
        } else {
            this.basketProducts.push({id: productId, count: count});
        }
        this.basketNotification = true;
        window.localStorage.setItem('_basket', JSON.stringify(this.basketProducts));
        Alpine.store('products').fetchProducts();
    },

    addEmpty(productId) {
        let product = this.basketProducts.find(p => p.id === productId);
        if (!product) {
            this.basketProducts.push({id: productId, count: 1});
        }
        this.basketNotification = true;
        window.localStorage.setItem('_basket', JSON.stringify(this.basketProducts));
        Alpine.store('products').fetchProducts();
    },

    remove(productId) {
        let productIndex = this.basketProducts.findIndex(p => p.id === productId);
        if (productIndex > -1) {
            this.basketProducts.splice(productIndex, 1);

            window.localStorage.setItem('_basket', JSON.stringify(this.basketProducts));
        }
        Alpine.store('products').fetchProducts();
    },

    increase(productId) {
        let product = this.basketProducts.find(p => p.id === productId);
        if (product) {
            product.count++;

            window.localStorage.setItem('_basket', JSON.stringify(this.basketProducts));
        }
    },

    decrease(productId) {
        let product = this.basketProducts.find(p => p.id === productId);
        if (product && product.count > 1) {
            product.count--;

            window.localStorage.setItem('_basket', JSON.stringify(this.basketProducts));
        }
    },

    clear() {
        this.basketProducts = [];
        this.basketNotification = false;
        window.localStorage.removeItem('_basket');
        Alpine.store('products').fetchProducts();
    }
});